import {
  UnderlyingsDatesBlackoutDatesState,
  UnderlyingsDatesKey,
  UnderlyingsDatesPayload,
  UnderlyingsDatesSpecificDatesState,
} from 'state/underlyingsDates/underlyingsDatesState.model';

export type UnderlyingsDatesActions =
  | UnderlyingsBlackoutDatesRequested
  | UnderlyingsSpecificDatesRequested
  | UnderlyingsBlackoutDatesReceived
  | UnderlyingsSpecificDatesReceived
  | UnderlyingsSpecificDatesRequestFailed
  | UnderlyingsBlackoutDatesRequestFailed;

export type UnderlyingsBlackoutDatesRequested = ReturnType<typeof underlyingsBlackoutDatesRequested>;
export type UnderlyingsSpecificDatesRequested = ReturnType<typeof underlyingsSpecificDatesRequested>;

export type UnderlyingsBlackoutDatesReceived = ReturnType<typeof underlyingsBlackoutDatesReceived>;
export type UnderlyingsSpecificDatesReceived = ReturnType<typeof underlyingsSpecificDatesReceived>;

export function underlyingsBlackoutDatesRequested(underlyingsDatesPayload: UnderlyingsDatesPayload) {
  return { type: 'UNDERLYINGS_BLACKOUT_DATES_REQUESTED' as const, underlyingsDatesPayload };
}
export function underlyingsSpecificDatesRequested(underlyingsDatesPayload: UnderlyingsDatesPayload) {
  return { type: 'UNDERLYINGS_SPECIFIC_DATES_REQUESTED' as const, underlyingsDatesPayload };
}

export function underlyingsBlackoutDatesReceived(
  underlyingsDateKey: UnderlyingsDatesKey,
  dates: UnderlyingsDatesBlackoutDatesState,
) {
  return {
    type: 'UNDERLYINGS_BLACKOUT_DATES_RECEIVED' as const,
    underlyingsDateKey,
    underlyingBloombergCode: dates.underlyingBloombergCode,
    blackoutDates: dates.blackoutDates,
  };
}
export function underlyingsSpecificDatesReceived(
  underlyingsDateKey: UnderlyingsDatesKey,
  dates: UnderlyingsDatesSpecificDatesState,
) {
  return {
    type: 'UNDERLYINGS_SPECIFIC_DATES_RECEIVED' as const,
    underlyingsDateKey,
    underlyingBloombergCode: dates.underlyingBloombergCode,
    specificDates: dates.specificDates,
  };
}

export function underlyingsSpecificDatesRequestFailed(
  productType: string,
  productSubType: string,
  underlyingBloombergCode: string,
  error: string,
) {
  return {
    type: 'UNDERLYINGS_SPECIFIC_DATES_REQUEST_FAILED' as const,
    productType,
    productSubType,
    underlyingBloombergCode,
    error,
  };
}

export type UnderlyingsSpecificDatesRequestFailed = ReturnType<typeof underlyingsSpecificDatesRequestFailed>;

export function underlyingsBlackoutDatesRequestFailed(
  productType: string,
  productSubType: string,
  underlyingBloombergCode: string,
  error: string,
) {
  return {
    type: 'UNDERLYINGS_BLACKOUT_DATES_REQUEST_FAILED' as const,
    productType,
    productSubType,
    underlyingBloombergCode,
    error,
  };
}

export type UnderlyingsBlackoutDatesRequestFailed = ReturnType<typeof underlyingsBlackoutDatesRequestFailed>;
